export * as gzip from './gzip';
export * as wuid from './wuid';
export var getParams = function (param) {
    if (typeof param === 'function') {
        return param();
    }
    return param;
};
//# sourceMappingURL=index.js.map